// Plain text inputs masked via CSS so browsers never treat the form as a login and autofill it
export const noAutofillProps = {
  autoComplete: "off",
  "data-1p-ignore": true,
  "data-lpignore": "true",
  "data-form-type": "other",
}

export const maskedInputClassName = "[-webkit-text-security:disc]"
